import { KeyArrayMap } from "@merri/common";
import { Venue } from "../../venues/models/venue";

export class VenueAdminVenueInfo {
  venue: Venue;
  attributes: KeyArrayMap<string>;
}
